export default __webpack_public_path__ + "static/media/M4F_pop.ecf7ca3c.jpg";